module.exports = {
    'inquiry': {
        'isInquiry': true,
        'ethosDestinationModel': 'apply-prospect-inquiries',
        'isActive': true
    },
    'supplemental': {
        'isSupplemental': true,
        'ethosDestinationModel': '',
        'isActive': false
    },
    'application': {
        'isApplication': true,
        'ethosDestinationModel': 'apply-applications',
        'isActive': true
    },
    'aid': {
        'isApplication': true,
        'ethosDestinationModel': 'aid-applications',
        'isActive': true
    }
};
